import Connection from './connection'
import Store from './store'
import api from '../api'
import { observable } from 'mobx'

export default class RealtorAssociations extends Store {
  @observable raList = []

  constructor(scope) {
    super(new Connection('realtor_assocation', scope))
  }

  load() {
    return api.get('mls/realtor_associations').then(resp => {
      this.raList = this.records = resp.data
    })
  }

  autocompleteLabelGenerator = record => record.name

}



// WEBPACK FOOTER //
// client/stores/realtor_associations.js